"use client";

import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils";

const Separator = React.forwardRef<
  React.ComponentRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    muted?: boolean;
  }
>(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      muted = false,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      className={cn(
        "divider",
        {
          "divider-horizontal": orientation === "vertical",
          "before:bg-green-main after:bg-green-main": !muted,
        },
        className
      )}
      {...props}
    />
  )
);

Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
